"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendTwoFactorCodeMultichannel = sendTwoFactorCodeMultichannel;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _types = require("./types");
var _authenticateSendConfirmationCodeMultichannel = require("../../repositories/monolith-cian-realty/v1/authenticate-send-confirmation-code-multichannel");
const _excluded = ["subdomain"];
async function sendTwoFactorCodeMultichannel(dependencies, parameters) {
  const {
    httpApi,
    logger
  } = dependencies;
  const {
      subdomain
    } = parameters,
    restParameters = (0, _objectWithoutProperties2.default)(parameters, _excluded);
  try {
    const sendCodeResponse = await (0, _authenticateSendConfirmationCodeMultichannel.fetchAuthenticateSendConfirmationCodeMultichannel)({
      httpApi,
      parameters: restParameters,
      config: {
        subdomain,
        requestConfig: {
          headers: [['Content-Type', 'application/json']]
        }
      }
    });
    if (sendCodeResponse.statusCode !== 200) {
      return {
        status: _types.ESendTwoFactorCodeStatus.Failed,
        message: sendCodeResponse.response.message
      };
    }
    return {
      status: _types.ESendTwoFactorCodeStatus.Succeed,
      senderType: sendCodeResponse.response.senderType || null,
      secondsToRetry: sendCodeResponse.response.secondsToRetry || 60,
      timeStamp: new Date().getTime()
    };
  } catch (ex) {
    logger.error(ex, {
      domain: 'auth-widget.api.sendTwoFactorCodeMultichannel'
    });
    return {
      status: _types.ESendTwoFactorCodeStatus.Failed,
      message: 'Произошла непредвиденная ошибка'
    };
  }
}